<template>
  <div id="app">
    <router-view />
    <popup-loading v-if="loading"></popup-loading>
  </div>
</template>

<script>
import { PopupLoading } from './components/popup'
import { mapState } from 'vuex'

export default {
  components: {
    PopupLoading
  },
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<style lang="less">
@import './assets/css/public.less';
@font-face {
  font-family: 'MyFont1';
  src: url('./assets/fonts/Montserrat-SemiBold.ttf') format('truetype');
}
@font-face {
  font-family: 'MyFont2';
  src: url('./assets/fonts/Montserrat-Regular.ttf') format('truetype');
}
@font-face {
  font-family: 'MyFont3';
  src: url('./assets/fonts/Montserrat-Bold.otf') format('otf');
}
@font-face {
  font-family: 'MyFont4';
  src: url('./assets/fonts/Montserrat-Light.otf') format('otf');
}
@font-face {
  font-family: 'MyFont5';
  src: url('./assets/fonts/Montserrat-Medium.ttf') format('truetype');
}
@font-face {
  font-family: 'MyFont6';
  src: url('./assets/fonts/SOURCEHANSANSCN-MEDIUM.TTF') format('truetype');
}
@font-face {
  font-family: 'MyFont7';
  src: url('./assets/fonts/SOURCEHANSANSCN-BOLD.OTF') format('truetype');
}
@font-face {
  font-family: 'MyFont8';
  src: url('./assets/fonts/SOURCEHANSANSCN-REGULAR.OTF') format('truetype');
}

body {
  background: #F9F9F9;
  padding: 0;
  margin: 0;
  height: 100vh;
  color: #333333;
  font-family: 'MyFont1', 'MyFont2', 'MyFont3', 'MyFont4', 'MyFont5', 'MyFont6', 'MyFont7', 'MyFont8', Work Sans-Regular, Work Sans;

}
.p-2{
  padding: 20px;
}
#app {
  font-size: 28px;
}
.btn {
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background: linear-gradient(132deg, #1A2229 0%, #00AB46 100%);
  box-shadow: 0px 6px 10px 1px rgba(49, 200, 137, 0.2);
  border-radius: 60px 60px 60px 60px;
  font-size: 32px;
}
.text-success {
  color: #00AB46;
}
</style>
